import DemoRepository from "../../../../.remote/gatsby-imgly-source/android-10.4.0/docs/packages/VESDK/docs/android/shared/demo-repository";
import * as React from 'react';
export default {
  DemoRepository,
  React
};